import _ from 'underscore';
import dayjs from '../../../shared/services/dayjs.js';
import stammdatenService from './services/stammdatenService.js';
import systemNachrichtService from './services/systemNachrichtService.js';
import schichtService from './services/schichtService.js';
import HoverPopupService, { renderKamerabilderInPopup } from './services/hoverPopupService.js';
import { CalenderService } from '../../../shared/services/calenderService.js';
import { ObservableArray, avatarFarbeAusName, convertNumberToEuro, debounce, formatInputNumber, formatNumber2Decimals, initialenAusName, renderFilterListe } from './util.js';
import { Egfz } from '../../../shared/services/Egfz.js';
import StandortMapView from './standort_map.js';
import { Roles } from '../../../../domain/konstanten/Roles.js';
import { ZeitTyp } from '../../../../domain/konstanten/ZeitTyp.js';

// Debounced Funktion für das Update des Tagesumsatzes (muss vor den Handlern als const definiert werden)
const debouceUpdateTagesumsatz = debounce(async (args) => {
    const datum = document.querySelector('.cal-date-selected').getAttribute('aria-label');
    const sollumsatz = document.querySelector('#tu-soll-umsatz').value;
    const istumsatz = document.querySelector('#tu-ist-umsatz').value;
    const sollkosten = document.getElementById('tu-soll-kosten').value;

    await updateTagesumsatz(datum, parseFloat(sollumsatz, 10), parseFloat(istumsatz, 10), parseFloat(sollkosten, 10));
    if (args) {
        args.value = formatInputNumber(args.value);
    }
}, 1000);

window.myHandlers = window.myHandlers || {};
window.myVars = window.myVars || {};
window.myHandlers.setFilterStatus = setFilterStatus;
window.myHandlers.toggleFilterParent = toggleFilterParent;
window.myHandlers.debouceUpdateTagesumsatz = debouceUpdateTagesumsatz;
window.myHandlers.acceptSuggestionKey = acceptSuggestionKey;
window.myHandlers.acceptSuggestionIcon = acceptSuggestionIcon;
window.myHandlers.updateSuggestion = updateSuggestion;

// Variablen für die Geolocation Map
let standortMap;

const pairs = ObservableArray();
pairs.setCallback((pairsNeu) => countPairStatus(pairsNeu));

const debouceUpdateTU = debounce(async (args) => {
    await updateZeitInTagesuebersicht(args[0], args[1]);
}, 1250); // 1.25 Sekunden Debounce

const borderColors = {
    aktiv: 'var(--custom-green)',
    geplant: 'var(--custom-blue)',
    nichtAus: 'var(--custom-yellow)',
    fehlend: 'var(--custom-red)',
    beendet: 'black',
    bearbeitet: 'var(--primary-color)',
    frueh: 'var(--custom-circle-orange)',
    spaet: 'var(--custom-circle-orange)',
    krank: 'var(--custom-red)',
    urlaub: 'var(--custom-circle-darkgreen)',
    abwesend: 'var(--primary-color)',
};

const zeStatusText = {
    nichtAus: 'nicht ausgestempelt',
    frueh: 'zu früh',
    spaet: 'zu spät'
};

function countPairStatus(pairs) {
    let summeAktiv = 0;
    let summeGeplant = 0;
    let summeFehlt = 0;
    let summeBeendet = 0;
    let summeBearbeitet = 0;
    let summeKrank = 0;
    let summeUrlaub = 0;
    let summeAbwesend = 0;
    let summeNichtAus = 0;
    let summeSpaet = 0;
    let summeFrueh = 0;
    let summeUnbestaetigt = 0;
    let summeGesamt = 0;

    pairs.forEach((pair) => {
        summeGesamt++;
        if (pair.Zeiterfassung?.Bestaetigt === false) {
            summeUnbestaetigt++;
        }
        switch(pair.Status) {
            case 'aktiv':
                summeAktiv++;
                break;
            case 'geplant':
                summeGeplant++;
                break;
            case 'fehlend':
                summeFehlt++;
                break;
            case 'beendet':
                summeBeendet++;
                break;
            case 'bearbeitet':
                summeBearbeitet++;
                break;
            case 'krank':
                summeKrank++;
                break;
            case 'urlaub':
                summeUrlaub++;
                break;
            case 'abwesend':
                summeAbwesend++;
                break;
            default:
                break;
        }
        // zeiterfassung status wenn spät, früh oder nicht ausgestempelt
        // ArbeitAmFeiertag ist zwar EGFZ (ZeitTyp 3), zählt aber als Arbeit
        const istArbeitsZeit = pair.Zeiterfassung?.ZeitTyp > 3 || pair.Zeiterfassung?.Zeitbloecke?.[0]?.EgfzID === Egfz.ArbeitAmFeiertag;
        if (!_.isEmpty(pair.Dienstplan) && !_.isEmpty(pair.Zeiterfassung) && istArbeitsZeit) {
            if (dayjs(pair.Zeiterfassung.SchichtVon).diff(pair.Dienstplan.SchichtVon, 'minutes') >= 10) {
                summeSpaet++;
            }
            if (dayjs(pair.Dienstplan.SchichtVon).diff(pair.Zeiterfassung.SchichtVon, 'minutes') >= 10) {
                summeFrueh++;
            }
            if ((pair.Zeiterfassung.SchichtBis == '' && dayjs().isAfter(pair.Dienstplan.SchichtBis)) || pair.Zeiterfassung.SchichtBis == '' && dayjs().isAfter(pair.Dienstplan.SchichtBis, 'hour')) {
                summeNichtAus++;
            }
        } else if (!_.isEmpty(pair.Zeiterfassung)) {
            // auch nicht ausgestempelt wenn zeiterfassung 1 Tag her ist.
            if (pair.Zeiterfassung.SchichtBis == '' && dayjs().isAfter(dayjs(pair.Zeiterfassung.SchichtVon).add(24, 'hours'))) {
                summeNichtAus++;
            }
        }
    });

    const listHeader = document.body.querySelector('.tu-filter-bar');
    listHeader.querySelector('#tu-count-aktiv').innerText = summeAktiv;
    listHeader.querySelector('#tu-count-geplant').innerText = summeGeplant;
    listHeader.querySelector('#tu-count-nicht-aus').innerText = summeNichtAus;
    listHeader.querySelector('#tu-count-fehlt').innerText = summeFehlt;
    listHeader.querySelector('#tu-count-beendet').innerText = summeBeendet;
    listHeader.querySelector('#tu-count-bearbeitet').innerText = summeBearbeitet;
    listHeader.querySelector('#tu-count-krank').innerText = summeKrank;
    listHeader.querySelector('#tu-count-urlaub').innerText = summeUrlaub;
    listHeader.querySelector('#tu-count-abwesend').innerText = summeAbwesend;
    listHeader.querySelector('#tu-count-frueh').innerText = summeFrueh;
    listHeader.querySelector('#tu-count-spaet').innerText = summeSpaet;
    listHeader.querySelector('#tu-count-unbestaetigt').innerText = summeUnbestaetigt;
    listHeader.querySelector('#tu-count-alle').innerText = summeGesamt - summeAbwesend - summeKrank - summeUrlaub;
    listHeader.querySelector('#tu-count-alle-egfz').innerText = summeGesamt;
};

async function ladeTagesuebersicht(datum = new Date()) {
	// map init bevor wir Zeiten laden. standordMap muss initialisiert sein für die Events auf den Schichtbalken
	standortMap = new StandortMapView('sharedMapPopup');
	standortMap.initMap();
    await renderFilterListe(filterTagesuebersichtList, 'tu-filter-posten-auswahl');
    const calContainer = document.body.querySelector('.cal-container');
    const calService = new CalenderService(calContainer, datum, ladeSchichtPaare);
    // Initial Umsatz laden
    await leseTagesumsatz(calService.date.format('YYYY-MM-DD'));
    // Bei Datum Wechsel Tagesumsatz laden
    calService.addEventListener('render', async (event) => {
        console.log('render event: ', calService.date.format('YYYY-MM-DD'));
        await leseTagesumsatz(calService.date.format('YYYY-MM-DD'));
    });

    const budgetAccess = window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) || window.myVars.UserRoles.includes(Roles.Sachbearbeiter);
    document.querySelector('.summary-group').style.display = budgetAccess ? 'block' : 'none';
    
    // input felder mit kommazahlen
    document.querySelector('.tu-body').querySelectorAll('input[type="number"]').forEach(input => {
        input.addEventListener('blur', e => {
            input.value = formatInputNumber(e.target.value);
        });
    });
}

function startRefreshTimeout(datumSelected) {
    // altes Interval löschen
    clearTimeout(window.myVars.intervalTU);
    window.myVars.intervalTU = setTimeout(() => {
        // falls wir nicht mehr auf der richten seite sind, löschen wir das Timeout
        if (window.myVars.websiteStatus != 'tagesuebersicht') {
            clearTimeout(window.myVars.intervalTU);
            return;
        }
        ladeSchichtPaare(datumSelected);
    }, 30 * 1000); // jede 0.5min updaten
}

/**
 * lädt die Schicht Paare und rendert sie.
 * @param {dayjs} datumSelected 
 */
async function ladeSchichtPaare(datumSelected) {
    // refresh Interval bei neuladen resetten.
    startRefreshTimeout(datumSelected);
    console.log('Lade Tagesübersicht für:', datumSelected.format('DD.MM.YYYY'));
    document.getElementById('summary-date').innerText = datumSelected.format('DD.MM.YYYY');
    document.getElementById('tu-tagesdatum-display').innerText = datumSelected.format('DD.MM.YYYY');
    // Tag im Kalender markieren
    const calContainer = document.body.querySelector('.cal-container');
    calContainer.querySelector(`[aria-label="${datumSelected.format('YYYY-MM-DD')}"]`).classList.add('cal-date-selected');
    // lade Schichten vom Server
    const result = await fetchTagesschichten(datumSelected.format('YYYY-MM-DD'), stammdatenService.aktuelleBetriebsstaette);
    const unternehmen = await stammdatenService.holeUnternehmensdaten();
    const bestaetigungNotwendig = unternehmen.MitarbeiterAppEinstellungen?.SchichtBestaetigungNotwendig;
    // Liste der Schichten
    const list = document.querySelector('.tu-list');
    // Reset der Liste bei Neuladen
    list.innerHTML = '';
    // Vorlage der Schicht Paare
    const templateTu = document.body.querySelector('[tu-item-template]');
    let sollStd = 0;
    let istStd = 0;
    let sollKosten = 0;
    let istKosten = 0;
    let jetzt = dayjs();
    // Für jedes Paar rendern wir nun die Liste
    result.forEach((pair) => {
        // jedes Schichtpaar kann einen Zeiterfassung Status haben für früh, spät, nicht ausgestempelt
        pair.StatusZE = {};
        const newItem = templateTu.content.cloneNode(true).children[0];
        // 5. Spalte (Bestätigung) nur reservieren, falls die Schicht-Bestätigungspflicht aktiv ist.
        newItem.querySelector('.shift-body').classList.toggle('mit-bestaetigung', Boolean(bestaetigungNotwendig));
        newItem.querySelector('[aria-label="item-name"]').innerText = pair.Name;
        renderAvatar(pair, newItem);
        newItem.querySelector('[aria-label="item-posten"]').innerText = pair.Posten;
        newItem.querySelector('[aria-label="item-quali"]').innerText = `(${pair.Qualifikation})`;
        newItem.querySelector('[aria-label="dienstplan-status"]').innerText = pair.Status;
        // Vorerst wird der Rahmen des List Elements nach dem allgemeinen Status (aktiv, geplant, fehlend, beendet) gefärbt
        newItem.querySelector('[aria-label="dienstplan-status"]').style.backgroundColor = borderColors[pair.Status];
        // Wenn es eine Dienstplan Schicht gibt, dann Zeigen wir die wichtigsten Details an.
        if (!_.isEmpty(pair.Dienstplan)) {
            newItem.querySelector('[aria-label="dienstplan-von"]').innerText = dayjs(pair.Dienstplan.SchichtVon).tz().format('HH:mm');
            newItem.querySelector('[aria-label="dienstplan-bis"]').innerText = dayjs(pair.Dienstplan.SchichtBis).tz().format('HH:mm');
            newItem.querySelector('[aria-label="dienstplan-titel"]').innerText = pair.Dienstplan.Titel;
            sollStd += pair.Dienstplan.BezahlteZeitGesamt;
            sollKosten += pair.Sollkosten;
        }
        // Wenn es eine Zeiterfassung Schicht gibt, dann zeigen wir dessen Details an, ansonsten bleibt das Input gesperrt.
        const zeVonInput = newItem.querySelector('[aria-label="zeiterfassung-von"]');
        const zeBisInput = newItem.querySelector('[aria-label="zeiterfassung-bis"]');
        if (!_.isEmpty(pair.Zeiterfassung)) {
            zeVonInput.value = dayjs(pair.Zeiterfassung.SchichtVon).tz().format('HH:mm');
            zeVonInput.addEventListener('input', async (event) => debouceUpdateTU(pair.Zeiterfassung._id, event));
            zeVonInput.disabled = false;
            zeBisInput.value = pair.Zeiterfassung.SchichtBis ? dayjs(pair.Zeiterfassung.SchichtBis).tz().format('HH:mm') : '';
            zeBisInput.addEventListener('input', async (event) => debouceUpdateTU(pair.Zeiterfassung._id, event));
            zeBisInput.disabled = false;
            const titelEl = newItem.querySelector('[aria-label="dienstplan-titel"]');
            if (pair?.Zeiterfassung?.Titel && pair.Zeiterfassung.ZeitTyp == 3) {
                titelEl.innerText = pair.Zeiterfassung.Titel;
            }
            // Fallback Titel für Zeiterfassung ohne Dienstplan
            if (titelEl.innerText == '') {
                titelEl.innerText = 'Arbeit';
            }
            renderPauseZeiterfassung(pair, newItem);
            renderBezahlteZeiterfassung(pair, newItem);
            renderUmsatzZeiterfassung(pair, newItem);
            // Zeige Geolaction an falls vorhanden
            if (pair.Zeiterfassung?.GeolocationStart || pair.Zeiterfassung?.GeolocationEnde) {
                const needleIcon = newItem.querySelector('.zeiterfassung-geolocation');
                standortMap.addMapEvents(needleIcon, pair.Zeiterfassung.GeolocationStart, pair.Zeiterfassung.GeolocationEnde);
                needleIcon.style.display = '';
            }
            // Zeige Kamerabilder-Icon an falls vorhanden
            if (!_.isEmpty(pair.Zeiterfassung?.KameraBilder)) {
                const kameraIcon = newItem.querySelector('.zeiterfassung-kamera');
                addKameraHoverEvents(kameraIcon, pair.Zeiterfassung.KameraBilder, pair, newItem, bestaetigungNotwendig);
                kameraIcon.style.display = '';
            }
            // Zeige Bestätigt-Badge bzw. Bestätigen-Button an, falls die Einstellung aktiv ist
            renderBestaetigung(pair, newItem, bestaetigungNotwendig);
            // Ist Stunden und Kosten berechnen
            istStd += pair.Zeiterfassung.BezahlteZeitGesamt;
            istKosten += pair.Istkosten;
        }
        // bezahlte EGFZ Zeiten zum Soll addieren falls keine Dienstplan Schicht vorhanden ist
        if (_.isEmpty(pair.Dienstplan) && !_.isEmpty(pair.Zeiterfassung) && pair.Zeiterfassung.ZeitTyp == 3) {
            sollStd += pair.Zeiterfassung.BezahlteZeitGesamt;
            sollKosten += pair.Istkosten;
        }
        renderStatusZeiterfassung(pair, newItem, zeVonInput, zeBisInput);
        list.append(newItem);
        // wir wollen später Zugriff auf das HTML Element haben, dazu speichern wir das HTML Element einfach mit.
        pair.pairHTML = newItem;
    });
    // Soll und Ist Kosten Summen anzeigen
    updateSuggestion(false, sollKosten);
    document.getElementById('tu-ist-kosten').innerText = convertNumberToEuro(istKosten);
    document.getElementById('tu-ist-kosten').setAttribute('aria-value', istKosten);
    // Umsatz laden
    const umsatzSoll = document.getElementById('tu-soll-umsatz').value;
    if (umsatzSoll > 0) {
        const sollKostenInput = document.getElementById('tu-soll-kosten');
        const sollKostenUsed = sollKostenInput.value ? parseFloat(sollKostenInput.value, 10) : 0;
        document.getElementById('tu-soll-ku').innerText = formatNumber2Decimals(sollKostenUsed / umsatzSoll * 100) + '%';
    }
    const umsatzIst = document.getElementById('tu-ist-umsatz').value;
    if (umsatzIst > 0) {
        document.getElementById('tu-ist-ku').innerText = formatNumber2Decimals(istKosten / umsatzIst * 100) + '%';
    }
    // Wir setzen das Ergebnis in unser Observable Array, damit die countStatus Funktion ausgeführt wird.
    pairs.set(result);
    // Wir filtern auch gleich (falls schon filter ausgewählt wurden)
    filterTagesuebersichtList();
}

// Accept suggestion with keyboard
function acceptSuggestionKey(event) {
    const ghost = document.getElementById('tu-soll-kosten-ghost');
    const main = document.getElementById('tu-soll-kosten');
    if ((event.key === 'ArrowRight' || event.key === 'Tab') && ghost.value && main.value === '') {
      event.preventDefault();
      acceptSuggestion();
    }
}

// Accept suggestion by clicking the icon
function acceptSuggestionIcon() {
    const ghost = document.getElementById('tu-soll-kosten-ghost');
    if (ghost.value) {
        acceptSuggestion();
    }
}

// Take Sollkosten suggstion and hide suggestion from UI
function acceptSuggestion() {
    const main = document.getElementById('tu-soll-kosten');
    const ghost = document.getElementById('tu-soll-kosten-ghost');
    const icon = document.getElementById('tu-soll-kosten-icon');
    main.value = ghost.value;
    ghost.style.display = 'none';
    icon.classList.remove('show-icon');
    debouceUpdateTagesumsatz();
}

/**
 * Updated das Sollkosten Input feld, falls es vom Inputfeld aufgerufen wird, wird der Wert immer übernommen.
 * Wenn es innerhalb ladeSchichtPaare aufgerufen wird, wird nur die Vorschau aktualisiert.
 * @param {Boolean} fromInput 
 * @param {Number} sollkostenInit 
 */
function updateSuggestion(fromInput, sollkostenInit) {
    const main = document.getElementById('tu-soll-kosten');
    const ghost = document.getElementById('tu-soll-kosten-ghost');
    const icon = document.getElementById('tu-soll-kosten-icon');
    const userVal = main.value;
    let sollkosten = sollkostenInit;
    // Setting cost suggestion
    if (!sollkosten && sollkosten !== 0) {
        sollkosten = ghost.getAttribute('aria-value') || 0;
    }
    ghost.setAttribute('aria-value', sollkosten);
    const suggested = formatInputNumber(sollkosten); // Sollkosten basierend auf Dienstplan
    ghost.value = suggested;

    if (!userVal) {
      ghost.style.display = 'block';
      icon.classList.add('show-icon');
      main.setAttribute('aria-value', 0);
    } else {
      ghost.style.display = 'none';
      icon.classList.remove('show-icon');
      main.setAttribute('aria-value', sollkosten);
    }
    // nicht beim init updaten
    if (!sollkostenInit && fromInput) debouceUpdateTagesumsatz();
}


// Gemeinsames Hover-Popup für Kamerabilder, geteilt zwischen Tagesübersicht und Mitarbeiter > Zeiten.
const kameraPopup = new HoverPopupService('sharedKameraPopup');

/**
 * Registriert Hover-Events für ein Kamerabilder-Icon: zeigt das gemeinsame Popup an der Mausposition,
 * lädt die Bilder debounced nach (analog zur Standort-Map) und zeigt zusätzlich einen Bestätigen-Button,
 * falls die Schicht noch nicht bestätigt ist.
 * @param {HTMLElement} icon
 * @param {Array<{_id: string, Typ: string}>} bilder Kamerabilder-Metadaten (ohne Bilddaten) der Schicht
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {HTMLElement} htmlItem Das zugehörige Shift-Card Element
 * @param {boolean} bestaetigungNotwendig Unternehmenseinstellung
 */
function addKameraHoverEvents(icon, bilder, pair, htmlItem, bestaetigungNotwendig) {
    kameraPopup.addHoverEvents(
        icon,
        () => Promise.all(bilder.map((bild) => schichtService.leseKamerabild(bild._id))),
        (popup, geladeneBilder) => {
            renderKamerabilderInPopup(popup, geladeneBilder);
            if (bestaetigungNotwendig && pair.Zeiterfassung.Bestaetigt === false) {
                const bestaetigenBtn = document.createElement('button');
                bestaetigenBtn.type = 'button';
                bestaetigenBtn.className = 'kamera-popup-bestaetigen-btn';
                bestaetigenBtn.innerText = 'Schicht bestätigen';
                bestaetigenBtn.addEventListener('click', async () => {
                    const success = await bestaetigeSchichtUndAnimiere(pair, htmlItem);
                    if (success) kameraPopup.hide();
                });
                popup.appendChild(bestaetigenBtn);
            }
        }
    );
}

/**
 * Server Anfrage für die Schichten an einem bestimmten Tagesdatum für einen Betrieb
 * @param {*} datum
 * @param {*} betriebID
 * @returns array<Schichtpaare>
 */
async function fetchTagesschichten(datum, betriebID) {
    try {
        const response = await fetch(`/neolohn/api/tagesuebersicht/schichten/${betriebID}?datum=${datum}`);
        if (!response.ok) {
            const message = await response.text();
            systemNachrichtService.zeigeKleineNachricht(message, 0);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Fehler beim Laden der Schichten', -1);
    }
}

/**
 * Übernimmt Änderungen des Updates in die Oberfläche nach erfolgreichem update
 * @param {*} zeiterfassungID 
 * @param {*} event 
 */
async function updateZeitInTagesuebersicht(zeiterfassungID, event) {
    const pairIndex = pairs.get().findIndex((pair) => pair.Zeiterfassung?._id === zeiterfassungID);
    if (pairIndex >= 0) {
        const pair = pairs.get()[pairIndex];
        let zeiterfassung = pair.Zeiterfassung;
        const zeitParent = event.target.closest('.shift-card');
        const vonInput = zeitParent.querySelector('[aria-label="zeiterfassung-von"]');
        const vonStr = vonInput.value;
        // ohne Von Zeit, machen wir nix
        if (vonStr == '') return;
        const bisInput = zeitParent.querySelector('[aria-label="zeiterfassung-bis"]');
        const bisStr = bisInput.value;
        const umsatzInput = zeitParent.querySelector('[aria-label="zeiterfassung-umsatz"]');
        const umsatz = parseFloat(umsatzInput.value, 10);
        // Server Request ausführen
        const result = await updateTagesuebersichtSchicht(zeiterfassung._id, vonStr, bisStr, umsatz); 
        // Bei erfolgreichem Update, die Oberfläche aktualisieren
        if (result) {
            const datumSelected = dayjs(document.querySelector('.cal-date-selected').getAttribute('aria-label'));
            ladeSchichtPaare(dayjs(datumSelected));
        }
    }
}

/**
 * Zeigt das Profilbild des Mitarbeiters in der Schicht-Karte an, sonst die
 * Initialen auf deterministisch aus dem Namen abgeleiteter Farbe (analog zur
 * Mitarbeiter-Übersicht).
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {*} htmlItem Das zugehörige HTML Element
 */
function renderAvatar(pair, htmlItem) {
    const avatar = htmlItem.querySelector('[aria-label="item-avatar"]');
    if (!avatar) return;
    // Name liegt als "Nachname, Vorname" vor. Getrennt halten für korrekte Initialen,
    // und als "Vorname Nachname" zusammensetzen, damit Farbe mit der Mitarbeiter-Übersicht übereinstimmt.
    const [nachname = '', vorname = ''] = (pair.Name || '').split(',').map((teil) => teil.trim());
    const name = `${vorname} ${nachname}`.trim();
    const farbe = avatarFarbeAusName(name);
    avatar.style.setProperty('--ma-avatar-bg', farbe.bg);
    avatar.style.setProperty('--ma-avatar-fg', farbe.fg);
    avatar.querySelector('.shift-avatar-initialen').innerText = initialenAusName(vorname, nachname);
    const img = avatar.querySelector('.shift-avatar-img');
    if (pair.Avatar?.base64) {
        img.src = `data:${pair.Avatar.MimeType || 'image/png'};base64,${pair.Avatar.base64}`;
        img.alt = name;
        avatar.classList.add('has-foto');
    } else {
        img.removeAttribute('src');
        avatar.classList.remove('has-foto');
    }
}

/**
 * Zeigt die Pausenzeit und die einzelnen Pausen beim Hovern über der Pausenzeit an. Nutzt das gemeinsame
 * Hover-Popup (statt einer im Grid-Item verschachtelten Liste), damit die Anzeige nicht vom
 * "overflow: hidden" der Shift-Card abgeschnitten wird.
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {*} htmlItem Das zugehörige HTML Element
 */
function renderPauseZeiterfassung(pair, htmlItem) {
    if (pair.Zeiterfassung.PauseZeitGesamt >= 0) {
        const pauseTime = dayjs.duration(Math.round(dayjs.duration(pair.Zeiterfassung.PauseZeitGesamt, 'hours').asMinutes()), 'minutes').format('HH:mm');
        const pauseHTML = htmlItem.querySelector('[aria-label="zeiterfassung-pause"]');
        pauseHTML.innerText = pauseTime;
        const pausenBloecke = pair.Zeiterfassung.Zeitbloecke.filter((block) =>
            [Egfz.PauseBezahlt, Egfz.PauseUnbezahlt, Egfz.RaucherPauseBezahlt, Egfz.RaucherPauseUnbezahlt].includes(block.EgfzID)
        );
        if (pausenBloecke.length === 0) return;
        pauseHTML.parentNode.classList.add('hat-pausen');
        kameraPopup.addHoverEvents(
            pauseHTML.parentNode,
            () => Promise.resolve(pausenBloecke),
            (popup, bloecke) => renderPausenInfoPopup(popup, bloecke)
        );
    }
}

/**
 * Rendert die einzelnen Pausenblöcke (Zeitraum + Dauer) in das gemeinsame Hover-Popup.
 * @param {HTMLElement} popup
 * @param {Array<object>} pausenBloecke Zeitblöcke mit EgfzID einer Pausenart
 */
function renderPausenInfoPopup(popup, pausenBloecke) {
    const titel = document.createElement('div');
    titel.className = 'popup-titel';
    titel.innerHTML = '<i class="bi bi-cup-hot-fill"></i> Pausen';
    popup.appendChild(titel);
    pausenBloecke.forEach((block) => {
        const zeile = document.createElement('div');
        zeile.className = 'pause-popup-zeile';
        const dauerMin = Math.round(dayjs(block.BlockBis).diff(dayjs(block.BlockVon), 'minutes', true));
        zeile.innerHTML = `<span>${dayjs(block.BlockVon).tz().format('HH:mm')} – ${dayjs(block.BlockBis).tz().format('HH:mm')}</span><span class="pause-popup-dauer">${dauerMin} Min</span>`;
        popup.appendChild(zeile);
    });
}

/**
 * Zeigt die bezahlte Zeit der IST Schicht an.
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {*} htmlItem Das zuegehörige HTML Element
 */
function renderBezahlteZeiterfassung(pair, htmlItem) {
    if (pair.Zeiterfassung.BezahlteZeitGesamt >= 0) {
        const bezahltTime = dayjs.duration(Math.round(dayjs.duration(pair.Zeiterfassung.BezahlteZeitGesamt, 'hours').asMinutes()), 'minutes').format('HH:mm');
        const bezahltHTML = htmlItem.querySelector('[aria-label="zeiterfassung-bezahlt"]');
        bezahltHTML.innerText = bezahltTime;
        if (pair.Zeiterfassung.SchichtBis == '') {
            bezahltHTML.nextElementSibling.style.display = 'inline-block';
        }
    }
}

/**
 * Zeigt den Umsatz der IST Schicht an.
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {*} htmlItem Das zuegehörige HTML Element
 */
function renderUmsatzZeiterfassung(pair, htmlItem) {
    if (pair.Zeiterfassung) {
        const budgetAccess = window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) || window.myVars.UserRoles.includes(Roles.Sachbearbeiter);
        htmlItem.querySelector('.shift-finance').style.display = budgetAccess ? 'grid' : 'none';
        const umsatz = pair.Zeiterfassung.SchichtUmsatz || 0;
        const umsatzHTML = htmlItem.querySelector('[aria-label="zeiterfassung-umsatz"]');
        umsatzHTML.value = formatInputNumber(pair.Zeiterfassung.SchichtUmsatz);
        umsatzHTML.disabled = !budgetAccess || (pair.Zeiterfassung.ZeitTyp == ZeitTyp.EGFZ && pair.Zeiterfassung.Zeitbloecke[0]?.EgfzID !== Egfz.ArbeitAmFeiertag);
        umsatzHTML.addEventListener('input', async (event) => debouceUpdateTU(pair.Zeiterfassung._id, event));
        if (pair.AGKostenProStunde >= 0 && pair.Istkosten >= 0) {
            const kostenHTML = htmlItem.querySelector('[aria-label="zeiterfassung-kosten"]');
            const kosten = pair.Istkosten;
            kostenHTML.innerText = convertNumberToEuro(kosten);
            if (pair.AGKostenProStunde == 0) {
                const info = document.createElement('i');
                info.style.marginLeft = '2.5px';
                info.className = 'bi bi-info-circle';
                info.title = 'Der Mitarbeiter besitzt noch keinen Arbeitgeberkosten Schnittwert. Sie können dem Mitarbeiter einen Vorwert eintragen in seiner Historie.';
                kostenHTML.appendChild(info);
            }
            // anteil nur mit postiven Umsatz möglich
            if (umsatz > 0) {
                const anteilHTML = htmlItem.querySelector('[aria-label="zeiterfassung-kosten-umsatz"]');
                anteilHTML.innerText = formatNumber2Decimals(kosten / umsatz * 100) + '%';
            }
        }
    }
}

/**
 * Beschriftet und färbt das HTML Element je nach Status
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {*} htmlItem Das zuegehörige HTML Element
 * @param {*} vonInput Zeiterfassung Von Input
 * @param {*} bisInput Zeiterfassung Bis Input
 */
function renderStatusZeiterfassung(pair, htmlItem, vonInput, bisInput) {
    // Wenn es Dienstplan und Zeiterfassung Schichten gibt, dann können wir den Zeiterfassung Status ermitteln
    const itemStatus = htmlItem.querySelector('[aria-label="zeiterfassung-status"]');
    if (!_.isEmpty(pair.Dienstplan) && !_.isEmpty(pair.Zeiterfassung)) {
        // Reset der alten Farbkodierung
        itemStatus.innerText = '';
        vonInput.style.color = '';
        bisInput.style.background = '';
        // ArbeitAmFeiertag ist zwar EGFZ aber soll wie Arbeit behandelt werden (spät/früh/nicht-aus Statusanzeige)
        if (pair.Zeiterfassung.ZeitTyp == ZeitTyp.EGFZ && pair.Zeiterfassung.Zeitbloecke[0]?.EgfzID !== Egfz.ArbeitAmFeiertag) return;
        // Bei mehr als +5min Abweichung zum Dienstplan wird das Element mit rot als zu spät markiert.
        if (dayjs(pair.Zeiterfassung.SchichtVon).diff(pair.Dienstplan.SchichtVon, 'minutes') > 5) {
            const diff = dayjs(pair.Zeiterfassung.SchichtVon).diff(pair.Dienstplan.SchichtVon, 'minutes');
            itemStatus.innerText = diff < 100 ? `${diff} min ${zeStatusText['spaet']}` : zeStatusText['spaet'];
            vonInput.style.color = 'var(--custom-red)';
            pair.StatusZE['spaet'] = true;
        } else {
            pair.StatusZE['spaet'] = false;
        }
        // Bei mehr als -5min Abweichung zum Dienstplan wird das Element mit gelb als zu früh markiert.
        if (dayjs(pair.Dienstplan.SchichtVon).diff(pair.Zeiterfassung.SchichtVon, 'minutes') > 5) {
            const diff = dayjs(pair.Dienstplan.SchichtVon).diff(pair.Zeiterfassung.SchichtVon, 'minutes');
            itemStatus.innerText = diff < 100 ? `${diff} min ${zeStatusText['frueh']}` : zeStatusText['frueh'];
            vonInput.style.color = 'var(--custom-red)';
            pair.StatusZE['frueh'] = true;
        } else {
            pair.StatusZE['frueh'] = false;
        }
        // Falls die Zeiterfassung noch ein offenes Ende nach der Dienstplan Bis Zeit hat, dann wird dieser auch mit gelb als nicht ausgestempelt markiert.
        if ((pair.Zeiterfassung.SchichtBis == '' && dayjs().isAfter(pair.Dienstplan.SchichtBis))
            || (pair.Zeiterfassung.SchichtBis == '' && dayjs().isAfter(pair.Dienstplan.SchichtBis, 'hour'))) {
            pair.StatusZE['nichtAus'] = true;
            bisInput.style.borderColor = 'var(--custom-yellow)';
            bisInput.style.background = 'var(--custom-light-yellow)';
            itemStatus.innerText += itemStatus.innerText.length <= 0 ? zeStatusText['nichtAus'] : ` & ${zeStatusText['nichtAus']}`;
        } else {
            pair.StatusZE['nichtAus'] = false;
        }
        itemStatus.style.display = itemStatus.innerText ? '': 'none';
        itemStatus.style.backgroundColor = borderColors['spaet'];
    }
    // auch nicht ausgestempelt wenn zeiterfassung 1 Tag her ist.
    if (!_.isEmpty(pair.Zeiterfassung)) {
        if (!pair.StatusZE['nichtAus'] && pair.Zeiterfassung.SchichtBis == '' && dayjs().isAfter(dayjs(pair.Zeiterfassung.SchichtVon).add(24, 'hours'))) {
            pair.StatusZE['nichtAus'] = true;
            itemStatus.innerText += itemStatus.innerText.length <= 0 ? zeStatusText['nichtAus'] : ` & ${zeStatusText['nichtAus']}`;
            itemStatus.style.display = itemStatus.innerText ? '': 'none';
            itemStatus.style.backgroundColor = borderColors['nichtAus'];
        }
    }
}

/**
 * Zeigt den Bestätigt-Badge eines Shift-Cards an (grüner Haken statt orangem Fragezeichen).
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {HTMLElement} btn
 * @param {HTMLElement} icon
 */
function zeigeBestaetigtBadge(pair, btn, icon) {
    btn.classList.add('bestaetigt');
    icon.className = 'bi bi-check-circle-fill icon-unconfirmed';
    btn.title = pair.Zeiterfassung.BestaetigtVon
        ? `Bestätigt von ${pair.Zeiterfassung.BestaetigtVon} am ${dayjs(pair.Zeiterfassung.BestaetigtAm).tz().format('DD.MM.YYYY, HH:mm')}`
        : 'Bestätigt';
}

/**
 * Bestätigt eine Schicht am Server und animiert den Badge auf der Shift-Card in den bestätigten Zustand.
 * Wird sowohl vom Bestätigen-Button auf der Karte als auch vom Bestätigen-Button im Kamerabilder-Popup verwendet.
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {HTMLElement} htmlItem Das zugehörige Shift-Card Element
 * @returns {Promise<boolean>} true bei Erfolg
 */
async function bestaetigeSchichtUndAnimiere(pair, htmlItem) {
    const result = await schichtService.bestaetigeSchicht(pair.Zeiterfassung._id);
    if (!result) return false;
    pair.Zeiterfassung.Bestaetigt = true;
    pair.Zeiterfassung.BestaetigtVon = result.BestaetigtVon;
    pair.Zeiterfassung.BestaetigtAm = result.BestaetigtAm;
    const btn = htmlItem.querySelector('.zeiterfassung-bestaetigen-btn');
    const icon = btn.querySelector('.icon-unconfirmed');
    // Icon/Farbe erst in der Mitte der Animation umschalten (Button ist dort fast unsichtbar/klein)
    btn.classList.add('bestaetigen-animate');
    setTimeout(() => zeigeBestaetigtBadge(pair, btn, icon), 160);
    btn.addEventListener('animationend', () => btn.classList.remove('bestaetigen-animate'), { once: true });
    countPairStatus(pairs.get());
    filterTagesuebersichtList();
    return true;
}

/**
 * Zeigt den Bestätigt-Badge bzw. den Bestätigen-Button an (nur falls die Unternehmenseinstellung
 * "Schicht Bestätigung notwendig" aktiv ist) und bestätigt die Schicht per Klick.
 * @param {*} pair Das Dienstplan / Zeiterfassung Paar
 * @param {*} htmlItem Das zugehörige HTML Element
 * @param {boolean} bestaetigungNotwendig Unternehmenseinstellung
 */
function renderBestaetigung(pair, htmlItem, bestaetigungNotwendig) {
    if (!bestaetigungNotwendig) return;
    htmlItem.querySelector('.bestaetigung').style.display = 'block';
    const btn = htmlItem.querySelector('.zeiterfassung-bestaetigen-btn');
    const icon = btn.querySelector('.icon-unconfirmed');
    // Fehlendes Feld (Altdaten) gilt wie überall sonst als bereits bestätigt.
    if (pair.Zeiterfassung.Bestaetigt !== false) {
        zeigeBestaetigtBadge(pair, btn, icon);
        return;
    }
    btn.addEventListener('click', () => bestaetigeSchichtUndAnimiere(pair, htmlItem), { once: true });
}

/**
 * Sendet die Update Anfrage mit Von und Bis Zeit einer Zeiterfassungsschicht
 * @param {string} schichtID entsprechende Schicht 
 * @param {string} von HH:mm
 * @param {string} bis HH:mm
 * @returns neues Schichtobjekt
 */
async function updateTagesuebersichtSchicht(schichtID, von, bis, umsatz) {
    try {
        const response = await fetch('/neolohn/api/tagesuebersicht/schichten', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                SchichtID: schichtID,
                SchichtVon: von,
                SchichtBis: bis,
                SchichtUmsatz: umsatz
            })
        });
        if (!response.ok) {
            const message = await response.text();
            systemNachrichtService.zeigeKleineNachricht(message, 0);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        const result = await response.json();
        systemNachrichtService.zeigeKleineNachricht('Änderung erfolgreich!', 1);
        return result;
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Änderung fehlgeschlagen!', -1);
        return false;
    }
}

function setFilterStatus(thisElement) {
    thisElement.parentNode.querySelectorAll('.tu-filter-bar-btn').forEach((filter) => {
        filter.style.background = '';
        filter.classList.remove('tu-filter-status-active');
    });
    if (thisElement.id != '') {
        thisElement.classList.add('tu-filter-status-active');
    }
    filterTagesuebersichtList();
}

function filterStatus() {
    const filter = document.body.querySelector('.tu-filter-status-active');
    // Filter reset
    if (!filter) {
        return;
    }
    pairs.get().forEach((pair) => {
        if (filter.id == 'frueh' && !pair.StatusZE['frueh']) {
            pair.pairHTML.style.display = 'none';
        }
        if (filter.id == 'spaet' && !pair.StatusZE['spaet']) {
            pair.pairHTML.style.display = 'none';
        }
        if (filter.id == 'nicht-aus' && !pair.StatusZE['nichtAus']) {
            pair.pairHTML.style.display = 'none';
        }
        if (filter.id == 'unbestaetigt' && pair.Zeiterfassung?.Bestaetigt !== false) {
            pair.pairHTML.style.display = 'none';
        }
        if (filter.id != 'alle' && filter.id != pair.Status && !['frueh', 'spaet', 'nicht-aus', 'unbestaetigt'].includes(filter.id)) {
            pair.pairHTML.style.display = 'none';
        }
        if (filter.id == 'alle' && ['krank', 'urlaub', 'abwesend'].includes(pair.Status)) {
            pair.pairHTML.style.display = 'none';
        }
    });
}

/**
 * Klappt den Bereich Filter auf oder zu
 * @param {HTMLElement} thisElement 
 * @param {*} event 
 */
function toggleFilterParent(thisElement, event) {
    event.stopPropagation();
    thisElement.parentNode.querySelectorAll('.tu-filter-child').forEach((child) => {
        child.classList.toggle('hidden');
    });
    const className = 'tu-filter-parent-open';
    thisElement.classList.toggle(className);
}

/**
 * Filtert die Schichtpaare nach Auswahl an Posten
 */
function filterPosten() {
    const aktivePosten = [];
    // sammle alle aktiven Posten
    document.querySelectorAll('.tu-filter-child').forEach((child) => {
        if (child.querySelector('.tu-filter-child-input').checked) {
            aktivePosten.push(child.id);
        }
    });
    pairs.get().forEach((pair) => {
        if (!aktivePosten.includes(pair.PostenID)) {
            pair.pairHTML.style.display = 'none';
        }
    });
    countPairStatus(pairs.get());
    // Speichere Postenauswahl im Browser
    localStorage.setItem('tu-filter-posten-auswahl', aktivePosten);
}

/**
 * Recalculates the total costs (Soll and Ist) based on visible pairs after filtering
 */
function recalculateTotalCosts() {
    let filteredIstKosten = 0;
    let filteredSollKosten = 0;

    pairs.get().forEach((pair) => {
        // Only include costs from visible pairs
        if (pair.pairHTML.style.display !== 'none') {
            filteredIstKosten += pair.Istkosten || 0;
            // Calculate sollkosten: from Dienstplan or from Zeiterfassung if no Dienstplan
            if (!_.isEmpty(pair.Dienstplan)) {
                filteredSollKosten += pair.Sollkosten || 0;
            } else if (!_.isEmpty(pair.Zeiterfassung) && pair.Zeiterfassung.ZeitTyp == 3) {
                filteredSollKosten += pair.Istkosten || 0;
            }
        }
    });

    // Update the UI with filtered costs
    document.getElementById('tu-ist-kosten').innerText = convertNumberToEuro(filteredIstKosten);
    document.getElementById('tu-ist-kosten').setAttribute('aria-value', filteredIstKosten);
    
    // Update Soll Kosten suggestion with filtered value
    const ghost = document.getElementById('tu-soll-kosten-ghost');
    ghost.setAttribute('aria-value', filteredSollKosten);
    const main = document.getElementById('tu-soll-kosten');
    // Only update the suggestion display if the main input is empty
    if (!main.value) {
        ghost.value = formatInputNumber(filteredSollKosten);
    }
    
    // Update Soll Kosten cost percentage
    const umsatzSoll = document.getElementById('tu-soll-umsatz').value;
    const sollkostenForPercentage = main.value ? parseFloat(main.value, 10) : filteredSollKosten;
    if (umsatzSoll > 0) {
        document.getElementById('tu-soll-ku').innerText = formatNumber2Decimals(sollkostenForPercentage / umsatzSoll * 100) + '%';
    }
    
    // Update Ist Kosten cost percentage
    const umsatzIst = document.getElementById('tu-ist-umsatz').value;
    if (umsatzIst > 0) {
        document.getElementById('tu-ist-ku').innerText = formatNumber2Decimals(filteredIstKosten / umsatzIst * 100) + '%';
    } else {
        document.getElementById('tu-ist-ku').innerText = '—';
    }
}

/**
 * Damit Filter kombinierbar sind, müssen wir immer beide anwenden.
 */
function filterTagesuebersichtList() {
    // reset
    pairs.get().forEach((pair) => pair.pairHTML.style.display = 'flex');
    // filter posten
    filterPosten();
    // filter status
    filterStatus();
    // recalculate costs based on filtered pairs
    recalculateTotalCosts();
}

async function leseTagesumsatz(datum) {
    const budgetAccess = window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) || window.myVars.UserRoles.includes(Roles.Sachbearbeiter);
    if (!budgetAccess) return {};
    try {
        const response = await fetch(`/neolohn/api/tagesuebersicht/umsatz/${datum}?BetriebsstaetteID=${stammdatenService.aktuelleBetriebsstaette}`);
        if (!response.ok) {
            const msg = await response.text();
            systemNachrichtService.zeigeKleineNachricht(msg, 0);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        const umsatz = await response.json();
        document.getElementById('tu-soll-umsatz').value = umsatz.UmsatzSoll >= 0 ? umsatz.UmsatzSoll : '';
        document.getElementById('tu-ist-umsatz').value = umsatz.UmsatzIst >= 0 ? umsatz.UmsatzIst : '';
        document.getElementById('tu-soll-kosten').value = umsatz.KostenSoll >= 0 ? umsatz.KostenSoll : '';
        renderUmsatzKosten(umsatz);
        return umsatz;
    } catch (error) {
        console.log(error);
        return {};
    }
}

async function updateTagesumsatz(datum, sollumsatz, istumsatz, sollkosten) {
    const budgetAccess = window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) || window.myVars.UserRoles.includes(Roles.Sachbearbeiter);
    if (!budgetAccess) return {};
    try {
        const response = await fetch(`/neolohn/api/tagesuebersicht/umsatz?BetriebsstaetteID=${stammdatenService.aktuelleBetriebsstaette}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Datum: datum,
                UmsatzSoll: sollumsatz,
                UmsatzIst: istumsatz,
                KostenSoll: sollkosten
            })
        });
        if (!response.ok) {
            const msg = await response.text();
            systemNachrichtService.zeigeKleineNachricht(msg, 0);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        systemNachrichtService.zeigeKleineNachricht('Tagessummen erfolgreich aktualisiert!', 1);
        const umsatz = await response.json();
        renderUmsatzKosten(umsatz);
        // Recalculate cost percentages based on filtered pairs
        recalculateTotalCosts();
        return umsatz;
    } catch (error) {
        console.log(error);
        return {};
    }
}

function renderUmsatzKosten(umsatz) {
    if (umsatz.KostenSoll >= 0 && umsatz.KostenSoll !== null) {
        document.getElementById('tu-soll-kosten').value = formatInputNumber(umsatz.KostenSoll);
        document.getElementById('tu-soll-kosten').setAttribute('aria-value', umsatz.KostenSoll);
        document.getElementById('tu-soll-kosten-ghost').style.display = 'none';
        document.getElementById('tu-soll-kosten-icon').classList.remove('show-icon');
    }
    if (umsatz.UmsatzSoll >= 0) {
        document.getElementById('tu-soll-umsatz').value = formatInputNumber(umsatz.UmsatzSoll);
        const kostenSoll = umsatz.KostenSoll || 0;
        const kostenUmsatz = umsatz.UmsatzSoll > 0 ? formatNumber2Decimals(kostenSoll / umsatz.UmsatzSoll * 100) + '%' : '—';
        document.getElementById('tu-soll-ku').innerText = kostenUmsatz;
    } else {
        document.getElementById('tu-soll-ku').innerText = '—';
    }
    if (umsatz.UmsatzIst > 0) {
        document.getElementById('tu-ist-umsatz').value = formatInputNumber(umsatz.UmsatzIst);
        const kostenIst = document.getElementById('tu-ist-kosten').getAttribute('aria-value');
        const kostenUmsatz = umsatz.UmsatzIst > 0 ? formatNumber2Decimals(kostenIst / umsatz.UmsatzIst * 100) + '%' : '—';
        document.getElementById('tu-ist-ku').innerText = kostenUmsatz;
    } else {
        document.getElementById('tu-ist-ku').innerText = '—';
    }
}

export {
    ladeTagesuebersicht
};